import Items from './SectionItems';
import Control from './SectionControl';

export default {
  components: {
    Items,
    Control
  }
};
